<template>
  <div>
    <el-card class="mb-4" shadow="never">
      <div slot="header">
        <strong>Загальна статистика адміністраторів</strong>
      </div>
      <el-table
        border
        :data="totalStatistics"
        size="small"
        style="max-width: 1200px"
      >
        <el-table-column
          label="Email"
          prop="admin_email"
          style="width: 400px;"
        />
        <el-table-column
          v-if="selectedAction !== 'Редагування' && selectedPublicationsType !== 'contractors'"
          align="center"
          label="Створено оголошень"
          prop="products_created"
          width="180"
        />
        <el-table-column
          v-if="selectedAction !== 'Створення' && selectedPublicationsType !== 'contractors'"
          align="center"
          label="Відредаговано оголошень"
          prop="products_updated"
          width="200"
        />
        <el-table-column
          v-if="selectedAction !== 'Редагування' && selectedPublicationsType !== 'products'"
          align="center"
          label="Створено виконавців"
          prop="contractors_created"
          width="200"
        />
        <el-table-column
          v-if="selectedAction !== 'Створення' && selectedPublicationsType !== 'products'"
          align="center"
          label="Відредаговано виконавців"
          prop="contractors_updated"
          width="220"
        />
      </el-table>
    </el-card>

    <el-form
      ref="form"
      class="filter-form"
      inline
      label-position="top"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item label="Діапазон дат">
            <el-date-picker
              v-model="dataRange"
              format="yyyy/MM/dd"
              style="width: 100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change="loadData"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Адміністратор">
            <el-select
              v-model="selectedAdminId"
              clearable
              placeholder="Оберіть адміністратора"
              style="width: 100%"
              @change="loadData"
            >
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.email"
                :value="admin.int_id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Дія">
            <el-select
              v-model="selectedAction"
              clearable
              placeholder="Оберіть дію"
              style="width: 100%"
              @change="loadData"
            >
              <el-option
                v-for="action in actions"
                :key="action"
                :label="action"
                :value="action"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Тип публікацій">
            <el-select
              v-model="selectedPublicationsType"
              clearable
              placeholder="Оберіть тип"
              style="width: 100%"
              @change="loadData"
            >
              <el-option
                v-for="type in publicationTypes"
                :key="type"
                :label="publicationLabel(type)"
                :value="type"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      :data="statistics"
      stripe
      style="width: 100%"
    >
      <el-table-column
        align="center"
        label="Дата"
        prop="created_at"
        width="200"
      />
      <el-table-column
        align="center"
        label="Email"
        prop="admin_email"
        width="200"
      />
      <el-table-column
        align="center"
        label="Дія"
        prop="action"
        width="200"
      />
      <el-table-column
        align="center"
        label="Оголошення"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.product_id">
            <div class="flex items-center">
              <el-tag
                class="mr-2"
                disable-transitions
                effect="plain"
                style="max-width: 300px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; vertical-align: middle;"
                :title="scope.row.product_name"
                type="success"
              >
                {{ scope.row.product_name }}
              </el-tag>

              <el-button-group>
                <el-tooltip content="Дивитись в адмінці" :open-delay="0">
                  <el-button
                    size="small"
                    type="info"
                    @click="onViewProduct(scope.row.product_public_id)"
                  >
                    <i class="far fa-user" />
                  </el-button>
                </el-tooltip>

                <el-tooltip content="Дивитись на сайті" :open-delay="0">
                  <a
                    v-if="scope.row.product_frontend_url"
                    class="el-button el-button--info el-button--small"
                    :href="scope.row.product_frontend_url"
                    target="_blank"
                  >
                    <i class="fa fa-eye" />
                  </a>
                </el-tooltip>
              </el-button-group>
            </div>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="Виконавець"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.contractor_id">
            <div class="flex items-center">
              <el-tag
                class="mr-2"
                disable-transitions
                effect="plain"
                style="max-width: 300px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; vertical-align: middle;"
                type="info"
              >
                {{ scope.row.contractor_name }}
              </el-tag>

              <el-button-group>
                <el-tooltip content="Дивитись в адмінці" :open-delay="0">
                  <el-button
                    size="small"
                    type="info"
                    @click="onViewContractor(scope.row.contractor_public_id)"
                  >
                    <i class="far fa-user" />
                  </el-button>
                </el-tooltip>

                <el-tooltip content="Дивитись на сайті" :open-delay="0">
                  <a
                    v-if="scope.row.contractor_frontend_url"
                    class="el-button el-button--info el-button--small"
                    :href="scope.row.contractor_frontend_url"
                    target="_blank"
                  >
                    <i class="fa fa-eye" />
                  </a>
                </el-tooltip>
              </el-button-group>
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {format} from 'date-fns';

export default {
  name: 'List',
  data() {
    return {
      statistics: [],
      totalStatistics:[],
      dataRange:[],
      selectedAdminId: null,
      actions: [],
      selectedAction: null,
      publicationTypes: ['products', 'contractors'],
      selectedPublicationsType: null,
    }
  },

  computed: {
    ...mapState('admin-management', {
      admins: 'admins',
    }),
  },

  async mounted() {
    await this.getActions();
    await this.getAdmins();
    await this.getStatistics();
  },

  methods: {
    ...mapActions('admin-statistics', [
      'loadAdminStatistics',
      'loadTotalStatistics',
      'loadActions',
    ]),
    ...mapActions('admin-management', [
      'fetchAdmins',
    ]),

    publicationLabel(type) {
      const map = {
        products: 'Оголошення',
        contractors: 'Виконавці',
      };
      return map[type] || type;
    },

    loadData() {
      this.getStatistics()
    },

    async getStatistics() {
      this.statistics = []
      this.totalStatistics = []
      const date = new Date()
      const defaultDate = format(date, 'yyyy-MM-dd')

      if (!this.dataRange.length) {
        this.dataRange.push(defaultDate)
        this.dataRange.push(defaultDate)
      }

      let data = {
        date_from: this.dataRange[0],
        date_to: this.dataRange[1],
        admin_id: this.selectedAdminId,
        action: this.selectedAction,
        publication_type: this.selectedPublicationsType,
      }

      let result = await this.loadAdminStatistics({data: data});
      this.statistics = result.statistics;
      this.totalStatistics = result.total_statistics;
    },
    async getActions() {
      this.actions = await this.loadActions();
    },
    async getAdmins() {
      await this.fetchAdmins();
    },
    onViewProduct(id) {
      const url = this.$router.resolve({ name: 'ViewProducts', params: { id } }).href;
      window.open(url, '_blank');
    },
    onViewContractor(id) {
      const url = this.$router.resolve({ name: 'ViewContractor', params: { id } }).href;
      window.open(url, '_blank');
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/_variables"

.mb-4
  margin-bottom: 20px

</style>
